module.exports = __webpack_public_path__ + "img/melia-room-4.bee924aa.jpg";